import { Link } from "react-router-dom";

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20manga-style%20banner%20background%2C%20warm%20rich%20red%20and%20dark%20crimson%20gradient%20tones%2C%20abstract%20flowing%20ink%20brush%20strokes%2C%20golden%20accents%20floating%20like%20sparks%2C%20elegant%20and%20mysterious%20atmosphere%2C%20Japanese%20ukiyo-e%20inspired%20composition%2C%20no%20text%2C%20no%20characters&width=1800&height=800&seq=hero-banner-comic&orientation=landscape"
        alt="羞羞色漫"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/60"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 tracking-wide">
          羞羞色漫
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed mb-8">
          羞羞色漫是深受读者喜爱的成人漫画平台，汇聚海量精选漫画资源，涵盖多种风格与题材，画质清晰、更新及时，为18岁以上成年用户提供流畅阅读体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即探索精彩内容
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white text-sm md:text-base font-semibold rounded-full border border-white/20 hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-8 text-white/60 text-xs md:text-sm">
          <div className="flex items-center gap-2">
            <span className="text-2xl md:text-3xl font-bold text-accent-500">5000+</span>
            <span>精选漫画</span>
          </div>
          <div className="w-px h-6 bg-white/20"></div>
          <div className="flex items-center gap-2">
            <span className="text-2xl md:text-3xl font-bold text-accent-500">每日更新</span>
          </div>
          <div className="w-px h-6 bg-white/20"></div>
          <div className="flex items-center gap-2">
            <span className="text-2xl md:text-3xl font-bold text-accent-500">高清画质</span>
          </div>
        </div>
      </div>
    </section>
  );
}